
import ReactDOM from 'react-dom';
import './App.css';
import ApolloProvider from './ApolloProvider';

ReactDOM.render(
   ApolloProvider,
  document.getElementById('root')
);


